
import { Search, CheckSquare } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';

interface ProductSearchProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  isSelectionMode: boolean;
  toggleSelectionMode: () => void;
}

export function ProductSearch({ 
  searchQuery, 
  setSearchQuery, 
  isSelectionMode, 
  toggleSelectionMode 
}: ProductSearchProps) {
  return (
    <div className="flex items-center gap-2">
      <Button 
        onClick={toggleSelectionMode} 
        variant={isSelectionMode ? "secondary" : "outline"} 
        size="sm" 
        className="sm:hidden"
      >
        <CheckSquare className="mr-2 h-4 w-4" />
        {isSelectionMode ? "Exit" : "Select"}
      </Button>
      <div className="relative w-full max-w-sm">
        <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
        <Input
          placeholder="Search products..."
          className="pl-9"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>
    </div>
  );
}
